import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import type { Meeting } from "@repo/types";
import { MeetingMinutesEditorForm } from "./MeetingMinutesEditorForm";
import { MEETING_MOTIF } from "@/lib/constants";
import { Delta } from "quill/core";

export const MeetingMinutesDialog = ({
  meeting,
  open,
  setOpen,
  minutes,
}: {
  enableLinks?: boolean;
  meeting?: Meeting;
  open: boolean;
  minutes: null | Delta | string;
  setOpen: (open: boolean) => void;
}) => {
  const [key, setKey] = useState(0);
  const forceResetForm = () => setKey((key) => key + 1);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        preventClickout
        preventEscape
        className="relative top-[-50vh] overflow-visible"
      >
        <DialogHeader className={MEETING_MOTIF}>
          <DialogTitle>Meeting Minutes Editor</DialogTitle>
        </DialogHeader>
        <MeetingMinutesEditorForm
          key={key}
          meetingId={meeting?.id}
          minutes={minutes}
          handleCancel={() => setOpen(false)}
          handleSubmit={() => {
            setOpen(false);
            forceResetForm();
          }}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
